import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Stack, TextField, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowDown01Icon} from "@hugeicons/core-free-icons";

export const DEFAULT_TRUNK = "twilio-na-us";
export const DEFAULT_CONTEXT = "from-internal";

// Collapsed trunk / context fields shared by the add and edit extension forms
export const ExtensionAdvancedSettings = ({trunk, context, onTrunkChange, onContextChange}) => {
  return (
    <Accordion
      disableGutters elevation={0}
      sx={{border: 1, borderColor: "divider", borderRadius: 2, "&:before": {display: "none"}}}
    >
      <AccordionSummary expandIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18}/>}>
        <Typography fontSize={14} fontWeight={500}>Advanced settings</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack gap={2}>
          <TextField
            label="Trunk" fullWidth size="small"
            value={trunk} onChange={(e) => onTrunkChange(e.target.value)}
            helperText={`Outbound trunk for calls from this extension (default: ${DEFAULT_TRUNK})`}
          />
          <TextField
            label="Context" fullWidth size="small"
            value={context} onChange={(e) => onContextChange(e.target.value)}
            helperText={`Dialplan context of the extension (default: ${DEFAULT_CONTEXT})`}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
